var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTotalEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_7489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4467 20.6148H32.4299C33.1756 20.6148 33.8266 21.0674 34.087 21.752C34.3237 22.3437 34.1225 23.2023 33.5544 23.6665L18.6529 35.6989C18.0256 36.1978 17.1261 36.2094 16.487 35.7453C15.836 35.2695 15.6111 34.4225 15.9307 33.6915L20.1324 23.9565H13.1492C12.4036 23.9565 11.7526 23.5968 11.4922 22.9123C11.2555 22.2277 11.4567 21.4619 12.0248 20.9978L26.9262 8.96535C27.5535 8.37359 28.4531 8.45481 29.0922 8.91894C29.7432 9.39466 29.9681 10.2417 29.6485 10.9727L25.4467 20.6032V20.6148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.8187 11.5657L13.8637 21.4127C13.4079 21.7926 13.237 22.4193 13.4364 22.9795C13.6358 23.5398 14.1675 23.8341 14.7658 23.8341H20.3682L16.9973 31.801C16.7409 32.3992 16.9308 33.0924 17.4436 33.4818C17.9658 33.8711 18.6875 33.8521 19.1813 33.4438L31.1363 23.5968C31.5921 23.2169 31.763 22.5142 31.5636 22.03C31.3642 21.4697 30.8325 21.0994 30.2342 21.0994H24.6318L28.0027 13.218C28.2591 12.6198 28.0692 11.9266 27.5565 11.5372C27.0342 11.1479 26.3125 11.0909 25.8187 11.5752V11.5657ZM0 22.4953C0 10.0749 10.0749 0 22.4953 0C34.9156 0 44.9905 10.0749 44.9905 22.4953C44.9905 34.9156 34.9156 44.9905 22.4953 44.9905C10.0749 44.9905 0 34.9251 0 22.4953Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_7489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTotalEnergy);
export default __webpack_public_path__ + "static/media/ic_total_energy.8f3e51d04a7c2b1542e05d91fd1509e6.svg";
export { ForwardRef as ReactComponent };